import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { searchCraftAPI } from "../../../api/service";
import { ISearchTemplateSlice } from "../../../api/craft/model/ISearchTemplateSlice";

const INITIAL_STATE = {
  response: null,
  loading: false,
  error: null,
  status: "idle",
} as ISearchTemplateSlice;

export const _searchTemplateById = createAsyncThunk(
  "api/craftmanagement/SearchTempleteById",
  searchCraftAPI.searchTemplateById
);

export const searchTemplateByIdSlice = createSlice({
  name: "searchTemplateById",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(_searchTemplateById.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(_searchTemplateById.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.response = action.payload.data;
        state.status = "succeeded";
      })
      .addCase(_searchTemplateById.rejected, (state, action) => {
        state.loading = false;
        state.response = null;
        state.error = action.payload;
        state.status = "failed";
      });
  },
});
